import { render } from "./basic_user_card.vue?vue&type=template&id=d8a50982"
import script from "./basic_user_card.js?vue&type=script&lang=js"
export * from "./basic_user_card.js?vue&type=script&lang=js"

import "./basic_user_card.vue?vue&type=style&index=0&id=d8a50982&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__